import axios from "axios";
import Config from "@/config.json"

const DEFAULT_LIMIT = 25;
const API_KEY = Config.VUE_APP_GIPHY_API_KEY;
const API_URL = 'https://api.giphy.com/v1';

export const searchGifs = async ({
  offset = 0,
  limit = DEFAULT_LIMIT,
  lang = 'en',
  q = '',
  rating = 'g' // g, pg, pg-13, r - more info at https://developers.giphy.com/docs/optional-settings#rating
} = {}) => {
  if (!q) {
    return await getTrendingGifs();
  }

  try {
    const resp = await axios.get(`${API_URL}/gifs/search?api_key=${API_KEY}&offset=${offset}&lang=${lang}&q=${q}&limit=${limit}&rating=${rating}`);

    return resp.data;
  } catch (error) {
    return { error };
  }
};

export const getTrendingGifs = async ({
  offset = 0,
  limit = DEFAULT_LIMIT,
  rating = 'g' // g, pg, pg-13, r - more info at https://developers.giphy.com/docs/optional-settings#rating
} = {}) => {
  try {
    const resp = await axios.get(`${API_URL}/gifs/trending?api_key=${API_KEY}&offset=${offset}&limit=${limit}&rating=${rating}`);

    return resp.data;
  } catch (error) {
    return { error };
  }
};

export const searchTags = async ({
  q = ''
} = {}) => {
  if (!q) return {};

  try {
    const resp = await axios.get(`${API_URL}/gifs/search/tags?api_key=${API_KEY}&q=${q}`);
    return resp.data;
  } catch (error) {
    return { error };
  }
}